var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEquipment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3800_7168)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.0625 7.10938C4.0625 4.26994 6.00453 1.88409 8.63281 1.20763C8.13511 1.07976 7.62325 1.01525 7.10938 1.01563C3.7439 1.01563 1.01562 3.7439 1.01562 7.10938C1.01562 10.4749 3.7439 13.2031 7.10938 13.2031C7.63542 13.2031 8.14587 13.1365 8.63281 13.0111C6.00453 12.3347 4.0625 9.94881 4.0625 7.10938Z",
    fill: "url(#paint0_linear_3800_7168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1719 16.4174V22.9531C11.1719 24.0749 10.2624 24.9843 9.14062 24.9843H5.07812C3.95632 24.9843 3.04688 24.0749 3.04688 22.9531V11.6514M15.2344 18.2812V21.3281C15.2344 22.4499 16.1438 23.3593 17.2656 23.3593H22.9531C24.0749 23.3593 24.9844 22.4499 24.9844 21.3281V15.2343C24.9844 14.1125 24.0749 13.2031 22.9531 13.2031H17.2656C16.1438 13.2031 15.2344 14.1125 15.2344 15.2343V18.2812ZM15.2344 18.2812H17.2656M15.2344 18.2812H11.1719M13.2031 7.10938C13.2031 10.4749 10.4749 13.2031 7.10938 13.2031C3.74389 13.2031 1.01562 10.4749 1.01562 7.10938C1.01562 3.74389 3.74389 1.01562 7.10938 1.01562C10.4749 1.01562 13.2031 3.74389 13.2031 7.10938ZM9.14062 7.10934C9.14062 8.23117 8.2312 9.14059 7.10938 9.14059C5.98755 9.14059 5.07812 8.23117 5.07812 7.10934C5.07812 5.98752 5.98755 5.07809 7.10938 5.07809C8.2312 5.07809 9.14062 5.98752 9.14062 7.10934Z",
    stroke: "url(#paint1_linear_3800_7168)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 1.01562V9.14062M15.2344 3.04688H19.2969M22.9531 1.01562V9.14062M20.9219 7.10938H24.9844",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3800_7168",
    x1: 1.01562,
    y1: 1.01562,
    x2: 11.418,
    y2: 9.96625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3800_7168",
    x1: 1.44445,
    y1: -1.67943,
    x2: 29.1602,
    y2: 24.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3800_7168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/equipment.5032a7730fe6ec63c37b19bafcb8293a.svg";
export { ForwardRef as ReactComponent };